import { Alert } from '@mui/material'
import { useTranslate } from '@tolgee/react'

export const ReleaseExpiredAssignmentAlert = () => {
  const { t } = useTranslate()
  return (
    <Alert severity='warning'>
      {t(
        'releaseExpiredAssignmentBlocked',
        'You can’t assign a new container to an expired release',
      )}
    </Alert>
  )
}
